/* eslint-disable @stylistic/indent */
import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { HttpClient, HttpContext } from '@angular/common/http';
import { IS_INTERCEPTING_ENABLED } from './core/interceptors/http.interceptor';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    private http = inject(HttpClient);

    getTranslation(lang: string) {
        return this.http.get<Translation>(`/assets/i18n/${lang}.json`, {
            context: new HttpContext().set(IS_INTERCEPTING_ENABLED, false)
        });
    }
}
